import { render, staticRenderFns } from "./InventoryFlowDetail.vue?vue&type=template&id=160fbbde&scoped=true"
import script from "./InventoryFlowDetail.vue?vue&type=script&lang=js"
export * from "./InventoryFlowDetail.vue?vue&type=script&lang=js"
import style0 from "./InventoryFlowDetail.vue?vue&type=style&index=0&id=160fbbde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160fbbde",
  null
  
)

export default component.exports